module.exports = __webpack_public_path__ + "media/images/signup_bg_mobile-1e31d2fb.png";